<div class="modal modal_size_744 modal_no-height modal__opened">
  <div class="modal__close icon icon-close" (click)="close()"></div>
  <div class="modal__container">

    <div app-group-item [group]="group" [showControls]="false"></div>

    <div class="modal__simple-field modal__simple-field-mb16 modal__simple-field-mt32">
      <span class="link link_with_arrow with-icon" (click)="edit()">{{ 'group-info-modal.edit-group' | translate }}</span>
    </div>
    <div class="modal__simple-field">
      <span class="link link_type_warning" (click)="delete()">{{ 'group-info-modal.delete-group' | translate }}</span>
    </div>
  </div>
</div>
